import { render } from "./HeroSection.vue?vue&type=template&id=7eceb5b1&scoped=true&ts=true"
import script from "./HeroSection.vue?vue&type=script&lang=ts"
export * from "./HeroSection.vue?vue&type=script&lang=ts"

import "./HeroSection.vue?vue&type=style&index=0&id=7eceb5b1&scoped=true&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eceb5b1"]])

export default __exports__